import { createAction, props } from '@ngrx/store';
import { userSettingsEntity } from './user-settings.models';

export const loadUserSettings = createAction('[User Settings] Load User Settings');

export const loadUserSettingsSuccess = createAction(
  '[User Settings] Load User Settings Success',
  props<{ userSettings: userSettingsEntity }>()
);

export const loadUserSettingsFailure = createAction(
  '[User Settings] Load User Settings Failure',
  props<{ error: any }>()
);

export const setUserSettings = createAction(
  '[User Settings] Set User Settings',
  props<{ key: string; value: string }>()
);

export const setUserSettingsSuccess = createAction(
  '[User Settings] Set User Settings Success',
  props<{ response: any }>()
);

export const setUserSettingsFailure = createAction(
  '[User Settings] Set User Settings Failure',
  props<{ error: any }>()
);

export const deleteUserSettings = createAction('[User Settings] Delete User Settings', props<{ key: string }>());

export const deleteUserSettingsSuccess = createAction(
  '[User Settings] Delete User Settings Success',
  props<{ response: any }>()
);

export const deleteUserSettingsFailure = createAction(
  '[User Settings] Delete User Settings Failure',
  props<{ error: any }>()
);
